/**
 * Read the server's own message off a failed API call.
 *
 * The API answers `{ error: { message, data } }`, so a bare axios error object says
 * nothing useful — showing `error.message` gives the user "Request failed with status
 * code 400" instead of the reason the server actually gave.
 *
 * Use this wherever a toast would otherwise show a generic fallback and the server has
 * something specific to say (which category name was unknown, which field was rejected).
 * For the category routes' structured 409 guard payload, use `readCategoryGuardError`
 * instead — it reads the machine-readable `reason` as well as the message.
 */
export function readApiErrorMessage(error: unknown): string | undefined {
  // The parameter is `unknown`, so it must actually behave that way: a caller passing
  // null/undefined (or a rejected non-Error) would otherwise throw on the property read,
  // turning an error handler into a second error.
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }
  const response = (error as { response?: { data?: { error?: { message?: string } } } }).response;
  return response?.data?.error?.message;
}
